import React from 'react';

const SANS = "'Plus Jakarta Sans', sans-serif";
const ALL_COLOR = '#5B7A93';

// Rounded-rect pills: All (grid icon) + one per boat (color dot). The active
// pill fills with the boat's signature color; picking one reskins the app.
export default function BoatSwitcher({ boats = [], activeId, onSelect }) {
  const items = [{ id: 'all', name: 'All', color: ALL_COLOR }, ...boats];
  return (
    <div style={{ display: 'flex', gap: 8, padding: '10px 12px 2px', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}
         className="boat-switcher">
      <style>{`.boat-switcher::-webkit-scrollbar{display:none}`}</style>
      {items.map(b => {
        const on = activeId === b.id;
        return (
          <button
            key={b.id}
            onClick={() => onSelect(b.id)}
            style={{
              flex: 'none', display: 'flex', alignItems: 'center', gap: 8,
              background: on ? b.color : 'var(--surface, #fff)',
              border: `1px solid ${on ? b.color : 'var(--border, #D5CCBA)'}`,
              borderRadius: 11, padding: '8px 14px', cursor: 'pointer',
              fontFamily: SANS, fontSize: 13, fontWeight: 700,
              color: on ? '#fff' : 'var(--navy, #1E2E3E)', whiteSpace: 'nowrap',
              boxShadow: on ? 'none' : '0 2px 6px rgba(11,22,38,.06)',
            }}
          >
            {b.id === 'all'
              ? <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
              : <span style={{ width: 9, height: 9, borderRadius: '50%', background: on ? '#fff' : b.color, flex: 'none' }} />}
            {b.name}
          </button>
        );
      })}
    </div>
  );
}
